export default {"src":"/_next/static/media/appStore_light_130x39.c8b7f3a7.svg","height":39,"width":130,"blurWidth":0,"blurHeight":0};